import {
  Issue,
  FieldMetadataForTypes as FieldMetadata,
  IssueStandardFieldIds,
  IssueAttributes,
} from "@adsk/acc-issues-types";

// if there is any data about field order on the type, it will take precedence.
// -- but if any custom or standard fields are not included in the data on the type,
// then those fields will be shown according to this order, after all of the
// fields that ARE in the ordering data on the type.
// In practice, the only time a field should be displayed that wasn't stored in the order
// is probably just custom fields that get added to the type's category,
// or because there's no data at all for the type because the order was not modified.
export const DEFAULT_FIELD_ORDER = [
  IssueStandardFieldIds.Description,
  IssueStandardFieldIds.Assignee,
  IssueStandardFieldIds.Watchers,
  IssueStandardFieldIds.Location,
  IssueStandardFieldIds.LocationDetails,
  IssueStandardFieldIds.GpsCoordinates,
  IssueStandardFieldIds.DueDate,
  IssueStandardFieldIds.StartDate,
  IssueStandardFieldIds.Placement,
  IssueStandardFieldIds.RootCauseWithCategory,
  IssueStandardFieldIds.Attachments,
  IssueStandardFieldIds.References,
] as const;

// fields that are shown under the custom fields by default
export const DEFAULT_BOTTOM_FIELDS = [
  IssueStandardFieldIds.Attachments,
  IssueStandardFieldIds.References,
] as const;

const getIssueValueFromFieldId = ({
  fieldId,
  issue,
  watcherProp,
}: {
  fieldId: IssueStandardFieldIds;
  issue: Issue | IssueAttributes;
  watcherProp: "watchers" | "watcherObjects";
}) => {
  let value;

  if (fieldId === IssueStandardFieldIds.Description) {
    value = issue.description;
  } else if (fieldId === IssueStandardFieldIds.Assignee) {
    value = issue.assignedTo;
  } else if (fieldId === IssueStandardFieldIds.Watchers) {
    value = issue[watcherProp];
  } else if (fieldId === IssueStandardFieldIds.Location) {
    value = issue.locationId;
  } else if (fieldId === IssueStandardFieldIds.LocationDetails) {
    value = issue.locationDetails;
  } else if (fieldId === IssueStandardFieldIds.DueDate) {
    value = issue.dueDate;
  } else if (fieldId === IssueStandardFieldIds.StartDate) {
    value = issue.startDate;
  } else if (fieldId === IssueStandardFieldIds.RootCauseWithCategory) {
    value = issue.rootCauseId;
  }

  return value;
};

export const getIssueValueFromFieldMetadata = ({
  field,
  issue,
  watcherProp,
}: {
  field: FieldMetadata;
  issue: Issue | IssueAttributes;
  watcherProp: "watchers" | "watcherObjects";
}) => {
  const { id: fieldId, type } = field;
  if (type === "standard") {
    return getIssueValueFromFieldId({
      fieldId: fieldId as IssueStandardFieldIds,
      issue,
      watcherProp,
    });
  } else {
    const customField = issue.customAttributes?.find(
      ({ attributeDefinitionId }) => attributeDefinitionId === fieldId
    );
    return customField?.value;
  }
};
